import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import { RootState } from './reducers';

// Overlay actions (blocking modal)
export const LOADING_OVERLAY_SHOW = 'LOADING_OVERLAY_SHOW';
export const LOADING_OVERLAY_HIDE = 'LOADING_OVERLAY_HIDE';

// Activity actions (non-blocking indicator)
export const ACTIVITY_START = 'ACTIVITY_START';
export const ACTIVITY_END = 'ACTIVITY_END';

// Network status
export const NETWORK_STATUS_SET = 'NETWORK_STATUS_SET';

export type NetworkStatus = 'offline' | 'slow' | 'fast';

type ShowLoadingOverlayOpts = {
  message?: string;
};

export const showLoadingOverlay =
  ({ message }: ShowLoadingOverlayOpts = {}): ThunkAction<
    void,
    RootState,
    unknown,
    AnyAction
  > =>
  dispatch => {
    dispatch({ type: LOADING_OVERLAY_SHOW, payload: { message } });
  };

export const hideLoadingOverlay =
  (): ThunkAction<void, RootState, unknown, AnyAction> => dispatch => {
    dispatch({ type: LOADING_OVERLAY_HIDE });
  };

// Hysteresis timer for fast recovery (avoids flickering)
let fastTimerId: ReturnType<typeof setTimeout> | null = null;

export const reportSlowNetwork =
  (): ThunkAction<void, RootState, unknown, AnyAction> =>
  (dispatch, getState) => {
    if (fastTimerId) {
      clearTimeout(fastTimerId);
      fastTimerId = null;
    }
    const status = getState().loading.networkStatus;
    if (status === 'slow' || status === 'offline') return;

    dispatch({ type: NETWORK_STATUS_SET, payload: 'slow' as NetworkStatus });
  };

export const reportFastNetwork =
  (): ThunkAction<void, RootState, unknown, AnyAction> =>
  (dispatch, getState) => {
    if (fastTimerId) return;
    if (getState().loading.networkStatus === 'fast') return;

    fastTimerId = setTimeout(() => {
      fastTimerId = null;
      if (getState().loading.networkStatus !== 'offline') {
        dispatch({ type: NETWORK_STATUS_SET, payload: 'fast' as NetworkStatus });
      }
    }, 3000);
  };

export const reportOffline =
  (): ThunkAction<void, RootState, unknown, AnyAction> => dispatch => {
    if (fastTimerId) {
      clearTimeout(fastTimerId);
      fastTimerId = null;
    }
    dispatch({ type: NETWORK_STATUS_SET, payload: 'offline' as NetworkStatus });
  };

export const reportOnline =
  (): ThunkAction<void, RootState, unknown, AnyAction> => dispatch => {
    if (fastTimerId) {
      clearTimeout(fastTimerId);
      fastTimerId = null;
    }
    dispatch({ type: NETWORK_STATUS_SET, payload: 'fast' as NetworkStatus });
  };
